@if (value) {
    <div class="label">
        <div class="label-title" id="attribute-label">
            {{ value }}
        </div>
    </div>
}
<div class="media">
    <ng-content></ng-content>
</div>
